<div class="employee-container" *ngIf="employeeReview">
    <div class="employee-container-inner">
        <div class="employee-image-container">
            <div dwRow>
                <div dwCol="12">
                    <h2>{{employeeHeadingDisplay}}</h2>
                </div>
            </div>
            <dw-image  [src]="employeeImageUrl" maxWidth="200px" maxHeight="200px" [defaultSrc]="defaultImageUrl"></dw-image>
            
            <!-- <img [src]="employeeImageUrl" [src2]="employeeImageUrl" class="employee-image" [defaultSrc]="defaultImageUrl" dwMagicImage maxWidth="250px" maxHeight="250px"> -->
        </div>
        <div class="review-details-container">
            <div dwRow>
                <div dwCol="12">
                    <label class="label">Eval Status</label>
                    <br>
                    <div class="pull-left">
                        {{ employeeReview.EmployeeReviewStatusIdDisplay }} 
                    </div>
                    <div class="pull-left" *ngIf="false">
                        @   <dw-readonly [(ngModel)]="employeeReview.SubmittedDateTime" formatType="datetime"></dw-readonly>
                    </div>
                 </div>
            </div>  
            
            <div dwRow class="mt-1">
                <div dwCol="12">
                    <label class="label">Due Date</label>
                    <dw-date2 [(ngModel)]="employeeReview.DueDate" (ngModelChange)="reviewUpdate()" *ngIf="!isReadOnly" [dateOptions]="dateOptions"></dw-date2>
                    <dw-readonly [(ngModel)]="employeeReview.DueDate" *ngIf="isReadOnly" formatType="date"></dw-readonly>
                </div>
            </div>

            <div dwRow class="mt-1" *ngIf="employeeReview.SubmittedDateTime">
                <div dwCol="12">
                    <label class="label">Submitted Date/Time</label>
                    <dw-readonly [(ngModel)]="employeeReview.SubmittedDateTime" formatType="datetime"></dw-readonly>
                </div>
            </div>

            <div dwRow class="mt-1" *ngIf="!employeeReview.SubmittedDateTime">
                <div dwCol="12">
                    <label class="label"> &nbsp;</label>
                    <div class="readonly">
                        &nbsp;
                    </div>
                </div>
            </div>

        </div>
        <div class="review-buttons-container">
            <div dwRow class="mt-4">
                <div dwCol="12">
                    <button class="btn btn-success hide-on-print" *ngIf="showEmployeeEval" (click)="gotoEval(false)" (middleclick)="gotoEval(true)">
                        <i class="fa fa-user-circle"></i>
                        Employee Eval
                    </button>
                    <button class="btn btn-primary ml-1 hide-on-print" *ngIf="showEmployeeEMS" (click)="gotoEMS(false)" (middleclick)="gotoEMS(true)">
                        <i class="fa fa-users"></i>
                        EMS
                    </button>
                    <button class="btn btn-warning hide-on-print" *ngIf="showSupervisorEval" (click)="gotoEval(false)" (middleclick)="gotoEval(true)">
                        <i class="fa fa-user-circle"></i>
                        Supervisor Eval
                    </button>
                </div> 
            </div>
        </div>
    </div>
    <div dwRow>
        <div dwCol="12">
            <h2>{{ethosUser?.NamePreferedLast}}</h2>
        </div>
    </div>
</div>